// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;
module.exports.TiDocumentText = function TiDocumentText(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "version": "1.2",
      "baseProfile": "tiny",
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "g",
      "attr": {},
      "child": [{
        "tag": "path",
        "attr": {
          "d": "M17 21h-10c-1.654 0-3-1.346-3-3v-12c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zm-10-16c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h10c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1h-10zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 8h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"
        }
      }]
    }]
  })(props);
};